import SummaryApi from '../common';
import service from '../common/HttpService';

export const fetchCropsList = async () => {
    try {
        const response = await service.get(SummaryApi.getCrop.url);
        let res = response;
        if (typeof res === 'string') {
            try { res = JSON.parse(res); } catch (e) {}
        }
        let extra = res?.extraData;
        if (typeof extra === 'string') {
            try { extra = JSON.parse(extra); } catch (e) {}
        }
        const cropsData = extra?.crop || res?.data?.crop || res?.crop || (Array.isArray(extra) ? extra : null);
        if (Array.isArray(cropsData)) {
            return cropsData.map(crop => ({
                id: String(crop.id || crop._id),
                name: (crop.name || crop.crop_name || "").trim(),
                image: crop.image || crop.crop_image || ""
            }));
        }
    } catch (err) {
        console.error("Error fetching crops list:", err);
    }
    return [];
};
